export default __webpack_public_path__ + "static/media/Geometos.f643a91a.ttf";